// extracted by mini-css-extract-plugin
export default {"Backdrop":"second_Backdrop__J0zzT","NavButtonA":"second_NavButtonA__VNleX","NavButton":"second_NavButton__4ldg+","Container":"second_Container__1YTq0"};